export default __webpack_public_path__ + "static/media/gitlab.d93ae4a9.gif";